module.exports = __webpack_public_path__ + "img/os3dor.66be9eb5.jpg";